/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
    DUMMY_BASE_URL,
    assertParamExists,
    setApiKeyToObject,
    setBasicAuthToObject,
    setBearerAuthToObject,
    setOAuthToObject,
    setSearchParams,
    serializeDataIfNeeded,
    toPathString,
    createRequestFunction,
} from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetCertificateShareLinkResponse } from '../models';
// @ts-ignore
import { GetCertificatesResponse } from '../models';
// @ts-ignore
import { GetCertificatesThumbnailsRequest } from '../models';
// @ts-ignore
import { GetCertificatesThumbnailsResponse } from '../models';
// @ts-ignore
import { RenderCertificateResponse } from '../models';
/**
 * CertificatesApi - axios parameter creator
 * @export
 */
export const CertificatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} certId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificatesApiControllerGetCertificateShareLink: async (
            certId: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'certId' is not null or undefined
            assertParamExists('certificatesApiControllerGetCertificateShareLink', 'certId', certId);
            const localVarPath = `/api/certificates/{certId}/share-link`.replace(
                `{${'certId'}}`,
                encodeURIComponent(String(certId))
            );
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificatesApiControllerGetCertificates: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/certificates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {GetCertificatesThumbnailsRequest} getCertificatesThumbnailsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificatesApiControllerGetCertificatesThumbnails: async (
            getCertificatesThumbnailsRequest: GetCertificatesThumbnailsRequest,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'getCertificatesThumbnailsRequest' is not null or undefined
            assertParamExists(
                'certificatesApiControllerGetCertificatesThumbnails',
                'getCertificatesThumbnailsRequest',
                getCertificatesThumbnailsRequest
            );
            const localVarPath = `/api/certificates/thumbnails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(
                getCertificatesThumbnailsRequest,
                localVarRequestOptions,
                configuration
            );

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} certId
         * @param {string} kind
         * @param {string} templateVersion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificatesApiControllerRenderCertificate: async (
            certId: string,
            kind: string,
            templateVersion: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'certId' is not null or undefined
            assertParamExists('certificatesApiControllerRenderCertificate', 'certId', certId);
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('certificatesApiControllerRenderCertificate', 'kind', kind);
            // verify required parameter 'templateVersion' is not null or undefined
            assertParamExists('certificatesApiControllerRenderCertificate', 'templateVersion', templateVersion);
            const localVarPath = `/api/certificates/{certId}/render`.replace(
                `{${'certId'}}`,
                encodeURIComponent(String(certId))
            );
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (templateVersion !== undefined) {
                localVarQueryParameter['templateVersion'] = templateVersion;
            }

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * CertificatesApi - functional programming interface
 * @export
 */
export const CertificatesApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = CertificatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} certId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificatesApiControllerGetCertificateShareLink(
            certId: string,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCertificateShareLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificatesApiControllerGetCertificateShareLink(
                certId,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificatesApiControllerGetCertificates(
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCertificatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificatesApiControllerGetCertificates(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {GetCertificatesThumbnailsRequest} getCertificatesThumbnailsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificatesApiControllerGetCertificatesThumbnails(
            getCertificatesThumbnailsRequest: GetCertificatesThumbnailsRequest,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCertificatesThumbnailsResponse>> {
            const localVarAxiosArgs =
                await localVarAxiosParamCreator.certificatesApiControllerGetCertificatesThumbnails(
                    getCertificatesThumbnailsRequest,
                    options
                );
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} certId
         * @param {string} kind
         * @param {string} templateVersion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificatesApiControllerRenderCertificate(
            certId: string,
            kind: string,
            templateVersion: string,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RenderCertificateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificatesApiControllerRenderCertificate(
                certId,
                kind,
                templateVersion,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};

/**
 * CertificatesApi - factory interface
 * @export
 */
export const CertificatesApiFactory = function (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance
) {
    const localVarFp = CertificatesApiFp(configuration);
    return {
        /**
         *
         * @param {string} certId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificatesApiControllerGetCertificateShareLink(
            certId: string,
            options?: any
        ): AxiosPromise<GetCertificateShareLinkResponse> {
            return localVarFp
                .certificatesApiControllerGetCertificateShareLink(certId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificatesApiControllerGetCertificates(options?: any): AxiosPromise<GetCertificatesResponse> {
            return localVarFp
                .certificatesApiControllerGetCertificates(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GetCertificatesThumbnailsRequest} getCertificatesThumbnailsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificatesApiControllerGetCertificatesThumbnails(
            getCertificatesThumbnailsRequest: GetCertificatesThumbnailsRequest,
            options?: any
        ): AxiosPromise<GetCertificatesThumbnailsResponse> {
            return localVarFp
                .certificatesApiControllerGetCertificatesThumbnails(getCertificatesThumbnailsRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} certId
         * @param {string} kind
         * @param {string} templateVersion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificatesApiControllerRenderCertificate(
            certId: string,
            kind: string,
            templateVersion: string,
            options?: any
        ): AxiosPromise<RenderCertificateResponse> {
            return localVarFp
                .certificatesApiControllerRenderCertificate(certId, kind, templateVersion, options)
                .then((request) => request(axios, basePath));
        },
    };
};

/**
 * CertificatesApi - object-oriented interface
 * @export
 * @class CertificatesApi
 * @extends {BaseAPI}
 */
export class CertificatesApi extends BaseAPI {
    /**
     *
     * @param {string} certId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificatesApi
     */
    public certificatesApiControllerGetCertificateShareLink(certId: string, options?: any) {
        return CertificatesApiFp(this.configuration)
            .certificatesApiControllerGetCertificateShareLink(certId, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificatesApi
     */
    public certificatesApiControllerGetCertificates(options?: any) {
        return CertificatesApiFp(this.configuration)
            .certificatesApiControllerGetCertificates(options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {GetCertificatesThumbnailsRequest} getCertificatesThumbnailsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificatesApi
     */
    public certificatesApiControllerGetCertificatesThumbnails(
        getCertificatesThumbnailsRequest: GetCertificatesThumbnailsRequest,
        options?: any
    ) {
        return CertificatesApiFp(this.configuration)
            .certificatesApiControllerGetCertificatesThumbnails(getCertificatesThumbnailsRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} certId
     * @param {string} kind
     * @param {string} templateVersion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificatesApi
     */
    public certificatesApiControllerRenderCertificate(
        certId: string,
        kind: string,
        templateVersion: string,
        options?: any
    ) {
        return CertificatesApiFp(this.configuration)
            .certificatesApiControllerRenderCertificate(certId, kind, templateVersion, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
